<script setup>
import {inject, reactive} from "vue";

const trans = inject('trans');

const fields = reactive([
  {
    name: 'company_name',
    title: trans('common.company_name'),
  },
  {
    name: 'owner.first_name',
    title: trans('common.first_name'),
  },
  {
    name: 'owner.last_name',
    title: trans('common.last_name'),
  },
  {
    name: 'contact_support_email',
    title: trans('common.email'),
  },
  {
    name: 'has_signed_contract',
    title: trans('dashboard.partner.partners.signed_partner_contract'),
    formatter: value => {
      return value
        ? '<div class="text-center text-center"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-labelledby="check-circle" role="presentation" class="fill-current text-success"><path d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-2.3-8.7l1.3 1.29 3.3-3.3a1 1 0 0 1 1.4 1.42l-4 4a1 1 0 0 1-1.4 0l-2-2a1 1 0 0 1 1.4-1.42z"></path></svg></div>'
        : '<div class="text-center text-center"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-labelledby="x-circle" role="presentation" class="fill-current text-danger"><path d="M4.93 19.07A10 10 0 1 1 19.07 4.93 10 10 0 0 1 4.93 19.07zm1.41-1.41A8 8 0 1 0 17.66 6.34 8 8 0 0 0 6.34 17.66zM13.41 12l1.42 1.41a1 1 0 1 1-1.42 1.42L12 13.4l-1.41 1.42a1 1 0 1 1-1.42-1.42L10.6 12l-1.42-1.41a1 1 0 1 1 1.42-1.42L12 10.6l1.41-1.42a1 1 0 1 1 1.42 1.42L13.4 12z"></path></svg></div>';
    }
  },
  {
    name: 'owner.is_accepted_terms',
    title: trans('dashboard.partner.accepted_terms_conditions'),
    formatter: value => {
      return value
        ? '<div class="text-center text-center"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-labelledby="check-circle" role="presentation" class="fill-current text-success"><path d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-2.3-8.7l1.3 1.29 3.3-3.3a1 1 0 0 1 1.4 1.42l-4 4a1 1 0 0 1-1.4 0l-2-2a1 1 0 0 1 1.4-1.42z"></path></svg></div>'
        : '<div class="text-center text-center"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-labelledby="x-circle" role="presentation" class="fill-current text-danger"><path d="M4.93 19.07A10 10 0 1 1 19.07 4.93 10 10 0 0 1 4.93 19.07zm1.41-1.41A8 8 0 1 0 17.66 6.34 8 8 0 0 0 6.34 17.66zM13.41 12l1.42 1.41a1 1 0 1 1-1.42 1.42L12 13.4l-1.41 1.42a1 1 0 1 1-1.42-1.42L10.6 12l-1.42-1.41a1 1 0 1 1 1.42-1.42L12 10.6l1.41-1.42a1 1 0 1 1 1.42 1.42L13.4 12z"></path></svg></div>';
    }
  },
  {
    name: 'id',
    title: trans('dashboard.Impersonate'),
  },
  {
    name: 'actions',
    title: trans('common.actions'),
  },
])

</script>

<template>
  <div class="partners">
    <div class="container tile mt-4 pb-4 mb-8">
      <loading-view :loading="false" class="mx-6">
        <div class="w-full">
          <div class="my-2 form_row pb-4">
            <h2 class="h4">{{ trans('common.Partners') }}</h2>
            <inertia-link :href="$route('dashboard.partner.partners.new')" class="button button_success">{{ trans('dashboard.partner.partners.add') }}</inertia-link>
          </div>

          <div class="my-2 pl-0 container">
            <vuetable
              :css="styling.table"
              ref="vuetable"
              :api-url="route('partner.partners.index')"
              :show-sort-icons="true"
              :fields="fields"
              data-path="data"
              pagination-path=""
              @vuetable:pagination-data="onPaginationData"
            >
              <template #id="{rowData}">
                <div v-if="rowData.has_signed_contract && rowData.owner.is_accepted_terms">
                  <a
                    class="impersonate cursor-pointer text-70 hover:text-primary no-underline inline-flex items-center text-center"
                    :href="route('dashboard.impersonate.start', {user: rowData.owner_id, return: 'dashboard.partner.partners.show'})"
                  >
                    <svg class="icon-1">
                      <use xlink:href="#impersonate-icon"></use>
                    </svg>
                    <span class="ml-2">{{ trans('dashboard.Impersonate') }}</span>
                  </a>
                </div>
                <div v-else>
                  <span class="text-danger cursor-not-allowed">
                    {{ trans('dashboard.partner.partners.action_is_not_allowed_yet') }}
                  </span>
                </div>
              </template>
              <template #actions="{rowData}">
                  <a
                    class="cursor-pointer text-70 hover:text-primary no-underline inline-flex items-center text-center"
                    :href="route('dashboard.partner.partners.edit', {partner: rowData.id})"
                  >
                    <svg class="icon-1">
                      <use xlink:href="#edit-icon"></use>
                    </svg>
                  </a>
              </template>
            </vuetable>
            <div style="margin-top: 10px">
              <vuetable-pagination ref="pagination"
                                   :css="styling.pagination"
                                   class="pull-right"
                                   @vuetable-pagination:change-page="onChangePage"/>
            </div>
          </div>
        </div>
      </loading-view>
    </div>
  </div>
</template>

<script>
import Vuetable from "vue3-vuetable";
import DashboardLayout from "@/Layouts/DashboardLayout";
import VuetablePagination from '@/components/Vuetable/Pagination';
import VuetableStyling from '@/components/Vuetable/Styling';

export default {
  name: 'Partners',

  layout: DashboardLayout,

  components: {
    Vuetable,
    VuetablePagination,
  },

  data() {
    return {
      styling: VuetableStyling,
    };
  },

  methods: {
    // when the pagination data is available, set it to pagination component
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    // when the user click something that causes the page to change,
    // call "changePage" method in Vuetable, so that that page will be
    // requested from the API endpoint.
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
  },
};
</script>

<style lang="scss">
.vuetable-body-wrapper {
  overflow: scroll;
  max-width: 100%;
}

.partners {
  padding-bottom: 4rem !important;
  display: block;

  .container {
    @media screen and (min-width: 1600px) {
      max-width: 1280px;
    }
    @media screen and (min-width: 1700px) {
      max-width: 1500px;
    }
  }
}
</style>
